// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__8VKLx","footer":"ReportModalFilter_footer__24EJJ"};